import { AnimatedText } from "../components/shared/AnimatedText";
import { FaqItem } from "../components/FAQ/FaqItem";

export function FaqSection({ t }) {
  return (
    <section id="faq" className="bg-white py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <AnimatedText text={t.faq.title} tag="h2" className="text-3xl md:text-4xl font-black text-blue-900 mb-3" />
            <AnimatedText text={t.faq.subtitle} tag="p" delay={80} className="text-gray-600 text-base" />
          </div>
          <div className="grid md:grid-cols-2 gap-3">
            {t.faq.items.map((item, idx) => (
              <FaqItem key={item.q} question={item.q} answer={item.a} delay={idx * 40} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
